export default __webpack_public_path__ + "static/media/team8.f308bb5f.png";